<template>
  <div class="sessions">
    <div class="head">
      <button class="new-btn" :disabled="creating" @click="onNewChat">
        <feather type="edit-3" size="16"/>
        <span>Новый чат</span>
      </button>
    </div>

    <div class="scroll">
      <div v-if="loading && !sessions.length" class="state">
        <b-spinner small/>
      </div>

      <div v-else-if="!sessions.length" class="state-empty">
        Диалогов пока нет
      </div>

      <ul v-else class="list">
        <li
            v-for="s in sessions"
            :key="s.id"
            :class="['item', { active: s.id === activeId }]"
            @click="$emit('select', s.id)"
        >
          <span class="title">{{ s.title || 'Новый чат' }}</span>
          <button
              class="trash"
              title="Удалить"
              @click.stop="onDelete(s)"
          >
            <feather type="trash-2" size="14"/>
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SessionsList',
  props: {
    sessions: { type: Array, default: () => [] },
    activeId: { type: [Number, String], default: null },
    loading: { type: Boolean, default: false },
    creating: { type: Boolean, default: false },
  },
  methods: {
    onNewChat() { this.$emit('create'); },
    onDelete(s) {
      if (!window.confirm('Точно удалить? Это действие нельзя отменить.')) return;
      this.$emit('delete', s.id);
    },
  },
};
</script>

<style scoped lang="scss">
.sessions {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.head {
  padding: 12px;
  border-bottom: 1px solid var(--ai-border);
}

.new-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 9px 12px;
  background: transparent;
  color: var(--ai-text);
  border: 1px solid var(--ai-border);
  border-radius: 10px;
  font-size: 13.5px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color .12s ease, border-color .12s ease;

  &:hover { background: var(--ai-sidebar-hover); }
  &:disabled { opacity: .55; cursor: default; }

  span { line-height: 1; }
}

.scroll {
  flex: 1;
  overflow-y: auto;
  padding: 4px 6px 12px;
}

.state {
  padding: 16px;
  display: flex;
  justify-content: center;
}
.state-empty {
  padding: 18px 14px;
  color: var(--ai-text-muted);
  font-size: 13px;
}

.list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.item {
  position: relative;
  display: flex;
  align-items: center;
  padding: 8px 10px;
  margin: 2px 4px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 13.5px;
  color: var(--ai-text);
  line-height: 1.3;
  transition: background-color .12s ease;

  .title {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-right: 4px;
  }

  .trash {
    flex: none;
    width: 26px;
    height: 26px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: none;
    border-radius: 6px;
    color: var(--ai-text-muted);
    opacity: 0;
    transition: opacity .12s ease, background-color .12s ease, color .12s ease;
    cursor: pointer;

    &:hover { background: rgba(0,0,0,0.06); color: var(--ai-danger); }
  }

  &:hover {
    background: var(--ai-sidebar-hover);
    .trash { opacity: 1; }
  }
  &.active {
    background: var(--ai-sidebar-active);
    .trash { opacity: 1; }
  }
}
</style>
